const key = 'AIzaSyCu-o-u1Bq3tTOY3T34Bjf4piZCt5160ws';
const version = '3.38';
const libraries = 'places';

const googleMaps = {
    url: `https://maps.googleapis.com/maps/api/js?key=${key}&v=${version}&libraries=${libraries}`,
};

const api = {
    upload: '/upload',
    import: '/eventimport',
};

const routes = {
    home: '/',
    news: '/news',
    newsDetail: '/news/:id',
    newsDelayedDetail: '/news-delayed/:id',
    newsAdd: '/news/add',
    infoCategories: '/info-categories',
    infoCategoriesAdd: '/info-categories/add',
    infoCategoriesDetail: '/info-categories/:id',
    infoAdd: '/info-categories/:id/info/add',
    infoDetail: '/info-categories/:categoryId/info/:id',
    maps: '/maps',
    pins: '/maps/pins',
    pinsAdd: '/maps/pins/add',
    pinsDetail: '/maps/pins/:id',
    imageMaps: '/maps/images',
    partners: '/partners',
    images: '/images',
};

const collections = {
    news: 'news',
    newsDelayed: 'newsDelayed',
};

const defaults = {
    projectName: 'app4event-admin',
    googleMaps,
    collections,
    api,
    routes,
};

export default defaults;
